import type { Board } from "../board";
import type { Direction } from "../direction";
import { BigSquid } from "../mobs/bigSquid";
import type { Player } from "../player";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class DebugRemoteControl extends Weapon {
	static key = "DebugRemoteControl";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.NONE;
	}

	fire(direction: Direction, board: Board): void {
		const bigSquid = board.getPhysicalThings().find((t) => t instanceof BigSquid) as BigSquid | undefined;
		if (bigSquid) {
			bigSquid.remoteControlDirection = direction;
		}
	}

	static deserialize(_data: any, owner: Player): DebugRemoteControl {
		return new DebugRemoteControl(owner);
	}
}
